import { Button, Panel } from "@coaching-culture/ui";
import { WidgetPanelHeader } from "pages/Dashboard/Widgets/WidgetPanelHeader";
import { ContinuousFeedbackTable } from "pages/Solutions/ContinuousFeedback/MyContinuousFeedback";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useHistory } from "react-router";
import styled from "styled-components";
import { grid, GridProps } from "styled-system";

const Widget = styled(Panel)<GridProps>`
  ${grid};
`;

export type FeedbackWidgetProps = {
  userId: string;
};

export const FeedbackWidget = ({ userId }: FeedbackWidgetProps) => {
  const history = useHistory();

  const requestFeedback = () => {
    history.push(`/solutions/continuous-feedback/request/${userId}`);
  };

  const giveFeedback = () => {
    history.push(`/solutions/continuous-feedback/send/${userId}`);
  };

  return (
    <Widget width={"100%"}>
      <WidgetPanelHeader title="Continuous feedback">
        <Button icon={FaArrowRight} onClick={giveFeedback}>
          Send feedback
        </Button>
        <Button onClick={requestFeedback} icon={FaArrowLeft}>
          Request feedback
        </Button>
      </WidgetPanelHeader>

      <ContinuousFeedbackTable userId={userId} />
    </Widget>
  );
};
